module.exports = __webpack_public_path__ + "static/media/ssam.9c606147.jpg";